import React from 'react';
import PropTypes from 'prop-types';

const CMSSettingsForm = ({ settings, generateLicense, generatingLicense, checkPermission, team, cmsLicenseKey }) => {
  function copyTextToClipboard(e) {
    let text = cmsLicenseKey;

    let textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();

    try {
      let successful = document.execCommand('copy');
      document.body.removeChild(textArea);
      alert(successful ? 'Copied to clipboard!' : 'Something went wrong...');
    } catch (err) {
      document.body.removeChild(textArea);
    }
  }

  return (
    <form className="table-container">
      <div className="container">
        Link everviz with your CMS for easier access to your published charts.
        <br />
        <a href="https://help.everviz.com/article/892-everviz-wordpress-plugin">
          Read more about our wordpress plugin here.
        </a>
      </div>
      <div className="table-btn-container">
        {cmsLicenseKey && cmsLicenseKey !== '' && (
          <div className="cms-license-key">
            <span className="license-label-text">License:</span>{' '}
            <span className="license-key-text">
              {cmsLicenseKey} &nbsp;
              <i onClick={copyTextToClipboard} className="fa fa-files-o clickable" aria-hidden="true" />
            </span>
          </div>
        )}
        {checkPermission('team_management') && (
          <input
            type="submit"
            disabled={generatingLicense}
            value={generatingLicense ? 'Generating...' : 'Generate license'}
            className="bulk-action bulk-action-btn inline"
            onClick={generateLicense}
          />
        )}
      </div>
    </form>
  );
};

CMSSettingsForm.propTypes = {
  settings: PropTypes.object.isRequired,
  generateLicense: PropTypes.func.isRequired,
  generatingLicense: PropTypes.bool,
  checkPermission: PropTypes.func,
  team: PropTypes.object,
  cmsLicenseKey: PropTypes.string
};

export default CMSSettingsForm;
